import { render, staticRenderFns } from "./MetricsAssetsUsage.vue?vue&type=template&id=67df96fb&scoped=true"
import script from "./MetricsAssetsUsage.vue?vue&type=script&lang=js"
export * from "./MetricsAssetsUsage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67df96fb",
  null
  
)

export default component.exports